import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/clients/profile/$tenantId')({
  staticData: { breadcrumb: 'Client Profile', breadcrumbKey: 'K_BREADCRUMB_TENANT_PROFILE' },
  validateSearch: (search: Record<string, unknown>): { edit?: boolean } => {
    if (search.edit === true || search.edit === 'true') return { edit: true };
    return {};
  },
});
